<template>
  <div class="wallet"> 
    <el-dialog title="开通有钱钱包"
     :visible.sync="dialogFormVisible"
     :close-on-click-modal="false"
     custom-class="walletdialog"
     top="10vh"
     v-loading="loading" 
     element-loading-text="拼命加载中" 
     element-loading-spinner="el-icon-loading" 
     element-loading-background="rgba(0, 0, 0, 0.8)"
     >
      <el-form :model="form" ref="form" :rules="rules" >
        <el-form-item prop="Phone">
          <div class="error3">
            <span class="colorr">*</span> 手机号:
          </div>
          <el-input v-model.trim="form.Phone" placeholder="请输入手机号"></el-input>
          <span class="error4 hint">请填写11位有效号码.</span>
        </el-form-item>
        <el-form-item prop="MsgCode">
          <div class="error3">
          <span class="colorr">*</span> 手机验证码:
          </div>
          <el-input v-model.trim="form.MsgCode" placeholder="请输入的验证码"></el-input>
          <el-button type="primary" size="small" @click="sendCode()" :disabled="isDisabled">{{buttonName}}</el-button>    
        </el-form-item>
        <el-form-item prop="CardNo">
          <div class="error3">
            <span class="colorr">*</span> 银行卡号:
          </div>
          <el-input v-model.trim="form.CardNo" placeholder="请输入银行卡号"></el-input>
        </el-form-item>
        <el-form-item prop="Email">
          <div class="error3">
            <span class="colorr"></span> 邮箱:
          </div>
          <el-input v-model.trim="form.Email" placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <el-form-item  prop="BankName">
          <div class="error3">
            <span class="colorr">*</span> 开户银行:
          </div>
          <el-select v-model="form.BankName" clearable placeholder="请选择银行" @focus="GetBankName()" @change="PickBankName">
            <el-option v-for="item in banklists" :key="item.Code" :label="item.Name" :value="item.Name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="ProName">
          <div class="error3">
            <span class="colorr"></span> 开户省份:
          </div>
          <el-select v-model="form.ProName" clearable placeholder="请选择所属省份" @focus="GetProvArea()" @change="PickProvCode">
            <el-option v-for="item in ProvArealists" :key="item.Code" :label="item.Name" :value="item.Name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="City">
          <div class="error3">
            <span class="colorr"></span> 市/县:
          </div>
          <el-select v-model="form.City" clearable placeholder="请选择所属市县" @change="PickCithCode">
            <el-option v-for="item in CityArealists" :key="item.Code" :label="item.Name" :value="item.Name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="SubBranchName">
          <div class="error3">
            <span class="colorr"></span> 支行名称:
          </div>
          <el-select v-model="form.SubBranchName" clearable placeholder="请选择开户支行名称" @change="PickOrga">
            <el-option v-for="item in GetOrgaNamelists" :key="item.Code" :label="item.Name" :value="item.Name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="SubBranchName" style="width: 30%;float:left; min-width: 260px;">
          <div class="error3">
            <span class="colorr">*</span> 身份证正面:
          </div>
          <el-upload class="avatar-uploader" :accept="imgAccept" action="" :show-file-list="false" :auto-upload="false" :on-change="changeFileFront">
            <!-- <img id="giftImgBack" v-if="form.SubBranchName" :src="form.SubBranchName" class="avatar"> -->
            <!-- <el-button v-else slot="trigger" class="btn_card" size="small" type="primary">身份证正面</el-button> -->
            <img v-if="form.IdCardFrontPath" :src="form.IdCardFrontPath" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item prop="SubBranchName" style="width: 30%;float:left; min-width: 260px;">
          <div class="error3">
            <span class="colorr">*</span> 身份证反面:
          </div>
          <el-upload class="avatar-uploader" :accept="imgAccept" action="" :show-file-list="false" :auto-upload="false" :on-change="changeFileBack">
            <!-- <img id="giftImgBack" v-if="form.SubBranchName" :src="form.SubBranchName" class="avatar"> -->
            <!-- <el-button v-else slot="trigger" class="btn_card" size="small" type="primary">身份证正面</el-button> -->
            <img v-if="form.IdCardBackPath" :src="form.IdCardBackPath" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false; resetForm('form')">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from "../../../static/config.json";
import Bus from "@/assets/js/bus";
export default {
  name: "wallet",
  data() {
    var reg = /^1[23456789]\d{9}$/;
    var validPhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入手机号码"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入正确的11位手机号码"));
      } else {
        callback();
      }
    };
    return {
      labelPosition: "right",
      loading: false,
      buttonName: "发送短信验证码",
      isDisabled: false,
      time: 60,
      rules: {
        Phone: [
          { required: true, trigger: "blur", validator: validPhone } //这里需要用到全局变量
        ],
        MsgCode: [
          { required: true, message: '请填写短信验证码', trigger: 'blur' }
        ],
        CardNo: [
          { required: true, message: '请填写银行卡号', trigger: 'blur' }
        ],
        BankName: [
          { required: true, message: '请选择开户银行', trigger: 'change' }
        ],
      },
      dialogFormVisible: false,
      form: {
        Phone: '',
        MsgCode: '',
        Email: '',
        CardNo: '',
        BankName: "",
        ProName: "",
        City: '',
        SubBranchName: '',
        IdCardFrontPath: '',
        IdCardBackPath: '',
      },
      imgAccept: "image/jpeg,image/jpg,image/png,image/bmp",
      imageUrl: '',
      BankCode: '',
      ProCode: '',
      CityCode: '',
      SubBranchCode: '',
      banklists: [],
      ProvArealists: [],
      CityArealists: [],
      GetOrgaNamelists: [],
      insTestProp: {
        WalletFileUploadUrl: '',
      }
    };
  },
  created() {
    this.insTestProp = JSON.parse(sessionStorage.getItem("insTestProp"));
  },
  mounted() {},
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.form.IdCardFrontPath == '') {
            this.$message.warning("请上传身份证正面！");
            return;
          }
          if (this.form.IdCardBackPath == '') {
            this.$message.warning("请上传身份证反面！");
            return;
          }
          let url = "/Wallet/WalletOpenAccount";
          let postData = this.form;
          this.loading = true;
          this.$loginapi.post(url, postData, response => {
            this.loading = false;
            if (response.Ret == 0) {
              this.$message.success(
                '请求已提交，请稍后查询开通结果'
              );
              this.dialogFormVisible = false;
              this.resetForm(formName);
            } else {
              this.$message.error(response.Msg);
            }
          });
        } else {
          this.$message.error('带 * 号为必填信息');
          return false;
        }
      });
    },
    //有钱钱包开通前验证
    WalletOpenAccountPre() {
      this.form = {
        Phone: '',
        MsgCode: '',
        Email: '',
        CardNo: '',
        BankName: "",
        ProName: '',
        City: '',
        SubBranchName: ''
      };
      let url = "/Wallet/WalletOpenAccountPre";
      let postData = "";
      this.$loginapi.post(url, postData, response => {
        if (response.Ret == 0) {
          this.form.Phone = response.Data.Phone;
          this.form.IdCardFrontPath = response.Data.IdCardFrontPath;
          this.form.IdCardBackPath = response.Data.IdCardBackPath;
          if (response.Data.UserBanks.length) {
            this.form.CardNo = response.Data.UserBanks[0].CardNO;
            this.form.BankName = response.Data.UserBanks[0].BankName;
            this.form.ProName = response.Data.UserBanks[0].ProvinceName;
            this.form.City = response.Data.UserBanks[0].CityName;
            this.form.SubBranchName = response.Data.UserBanks[0].SubbranchName;
            this.GetBankName();
            this.GetProvArea(true);
          }
          // console.log(this.form);
          this.dialogFormVisible = true;
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    // 银行列表
    GetBankName() {
      if (this.banklists.length) return;
      let url = "/login/GetBankName/" + this.$store.state.inscode;
      this.$loginapi.post(url, "", response => {
        if (response.Ret == 0) {
          if (response.Data.length > 0) {
            this.banklists = response.Data;
            if (this.form.BankName) {
              this.BankCode = '';
              this.banklists.forEach(item => {
                if (item.Name == this.form.BankName) {
                  this.BankCode = item.Code;
                }
              });
            }
          }
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    PickBankName(value) {
      this.BankCode = '';
      this.banklists.forEach(item => {
        if (item.Name == value) {
          this.BankCode = item.Code;
        }
      });
      this.form.BankName = value;
      this.ProvArealists = [];
      this.form.ProName = "";
      this.CityArealists = [];
      this.form.City = "";
      this.GetOrgaNamelists = [];
      this.form.SubBranchName = "";
    },
    // 省份列表
    GetProvArea(first) {
      if (this.ProvArealists.length) return;
      let url = "/login/GetProvArea/" + this.$store.state.inscode;
      this.$loginapi.post(url, "", response => {
        if (response.Ret == 0) {
          if (response.Data.length > 0) {
            this.ProvArealists = response.Data;
            if (this.form.ProName) {
              this.ProCode = '';
              this.ProvArealists.forEach(item => {
                if (item.Name == this.form.ProName) {
                  this.ProCode = item.Code;
                }
              });
            }
          }
          if (first) { // 第一次进入获取下拉市区列表
            this.GetCityArea(this.ProCode, true);
          }
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    PickProvCode(value) {
      this.ProCode = '';
      this.ProvArealists.forEach(item => {
        if (item.Name == value) {
          this.ProCode = item.Code;
        }
      });
      this.form.ProName = value;
      this.CityArealists = [];
      this.form.City = "";
      this.GetOrgaNamelists = [];
      this.form.SubBranchName = "";
      this.GetCityArea(this.ProCode);
    },
    GetCityArea(value, first) {
      if (value == "" || value == null) {
        return;
      }
      let postData = "provId=" + value;
      let url = "login/GetCityArea/" + this.$store.state.inscode;
      this.$api.post(url, postData, response => {
        if (response.Ret == 0) {
          this.CityArealists = response.Data;
          if (this.form.City) {
            this.CityCode = '';
            this.CityArealists.forEach(item => {
              if (item.Name == this.form.City) {
                this.CityCode = item.Code;
              }
            });
          }
          if (first) {
            this.GetOrgaName(this.CityCode);
          }
        } else {
          this.$message.error(data.Msg);
        }
      });
    },
    PickCithCode(value) {
      this.CityCode = '';
      this.CityArealists.forEach(item => {
        if (item.Name == value) {
          this.CityCode = item.Code;
        }
      });
      this.form.City = value;
      this.GetOrgaNamelists = [];
      this.form.SubBranchName = "";
      this.GetOrgaName(this.CityCode);
    },
    GetOrgaName(value) {
      if (value == "" || value == null) {
        return;
      }
      let url = "login/GetOrgaName/" + this.$store.state.inscode;
      let postData =
        "bankTypeId=" +
        this.BankCode +
        "&provId=" +
        this.ProCode +
        "&cityId=" +
        value;
      this.$api.post(url, postData, response => {
        if (response.Ret == 0) {
          this.GetOrgaNamelists = response.Data;
        } else {
          this.$message.error(data.Msg);
        }
      });
    },
    PickOrga(value) {
    },
    changeFileFront(file, fileList) {
      let isJPG = file.raw.type === "image/jpeg";
      let isPNG = file.raw.type === "image/png";
      let isBMP = file.raw.type === "image/bmp";
      let isLt100M = file.raw.size / 1024 / 1024 < 100;

      if (!isJPG && !isPNG && !isBMP) {
        this.$message.warning("上传图片必须是JPG/PNG/BMP 格式!");
        return;
      }
      if (!isLt100M) {
        this.$message.warning("上传图片大小不能超过 100MB!");
        return;
      }
      this.loading = true;
      var url = this.insTestProp.WalletFileUploadUrl + "/api/FileUpload/UploadWithFolder";
      // var url = "http://192.168.1.125:8000" + "/api/FileUpload/UploadWithFolder";
      var postData = {
        file: file.raw,
        FileType: 2
      };
      let This = this;
      this.$loginapi.postformWallte(url, postData, response => {
        this.loading = false;
        if (response.Ret === 0) {
          this.form.IdCardFrontPath = response.Data[0];
          this.$message.success(response.Msg);
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    changeFileBack(file, fileList) {
      let isJPG = file.raw.type === "image/jpeg";
      let isPNG = file.raw.type === "image/png";
      let isBMP = file.raw.type === "image/bmp";
      let isLt100M = file.raw.size / 1024 / 1024 < 100;

      if (!isJPG && !isPNG && !isBMP) {
        this.$message.warning("上传图片必须是JPG/PNG/BMP 格式!");
        return;
      }
      if (!isLt100M) {
        this.$message.warning("上传图片大小不能超过 100MB!");
        return;
      }
      this.loading = true;
      var url = this.insTestProp.WalletFileUploadUrl + "/api/FileUpload/UploadWithFolder";
      // var url = "http://192.168.1.125:8000" + "/api/FileUpload/UploadWithFolder";
      var postData = {
        file: file.raw,
        FileType: 2
      };
      let This = this;
      this.$loginapi.postformWallte(url, postData, response => {
        this.loading = false;
        if (response.Ret === 0) {
          this.form.IdCardBackPath = response.Data[0];
          this.$message.success(response.Msg);
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    //获取验证码
    sendCode() {
      this.$refs.form.validateField("Phone", errMsg => {
        if (errMsg) {
          this.$message.error("请输入正确的手机号");
          return;
        } else {
          let url = "Account/SendVerifyCodeToPhone";
          this.isDisabled = true;
          this.$loginapi.post(url, this.form.Phone, response => {
            if (response.Ret == 0) {
              this.$message.success("验证码已发送，请注意查收!");
              this.sendMsg();
            } else {
              this.isDisabled = false;
              this.$message.error(response.Msg);
            }
          });
        }
      });
    },
    // 短信验证倒计时
    sendMsg() {
      let me = this;
      me.isDisabled = true;
      let interval = window.setInterval(function() {
        me.buttonName = "（" + me.time + "s）发送";
        --me.time;
        if (me.time < 0) {
          me.buttonName = "发送短信验证码";
          me.time = 60;
          me.isDisabled = false;
          window.clearInterval(interval);
        }
      }, 1000);
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>

<style>
.wallet .el-input {
  width: 50% !important;
}
.wallet .el-select {
  display: block;
  width: 50% !important;
}
.wallet .el-select .el-input {
  width: 100% !important;
}
.wallet .walletdialog {
  min-width: 600px;
}
.wallet .walletdialog .el-dialog__body{
  max-height: 500px;
  overflow-y: auto;
}
.wallet .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
.wallet .avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.wallet .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.wallet .avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/modification/wallet.vue